import React from "react";
import { Input } from "antd";

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = "Search...",
  value,
  onChange,
  className = "",
}) => {
  return (
    <div className="relative w-full">
      <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-base z-10"></i>

      <Input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`w-full pl-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary ${className}`}
      />
    </div>
  );
};

export default SearchInput;
